import "./ElementFinder.css";
import { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Store } from "../../store";
import Visualizer from "../../components/Visualizer/Index";

import Loader from "../../components/Loader/Loader";

//API
import axios from "../../service/axios";

import useQueryParams from "../../hooks/useQueryParams";
import { transformElements } from "../../utils/helpers";

import { toast } from "react-toastify";
import { eventEmiterInstance } from "../../utils/EventEmitter";

const ElementFinder = () => {
  const { state, dispatch } = useContext(Store);
  const visualizerRef = useRef(null);


  const urlParams = useQueryParams();

  const [layoutId,setLayoutId] = useState(null);


  const navigate = useNavigate();

  const addParams = (key,value) => {
     // Create new URLSearchParams from current search string
    const currentParams = new URLSearchParams(location.search);

    // Add or update specific query parameters
    currentParams.set(key, value);

    // Update URL without triggering a full page reload
    navigate(`${location.pathname}?${currentParams.toString()}`, { 
      replace: true  // Replaces current entry in history
    });
  };



  //Fetch Layout Objects
  const fetchLayoutObjects = async (layoutId) => {
    visualizerRef?.current?.setLoading(true);
    try {
      const { data } = await axios.get(`layout-objects/${layoutId}`);
      const responseData = data?.data;
      if (!responseData.length) return;
      const elements = transformElements(responseData);

      // batch dispatch
      dispatch({
        type: "BATCH_DISPATCH",
        payload: [
          { type: "SET_ELEMENTS", payload: elements },
          { type: "SET_INITIAL_LOAD", payload: true },
        ],
      });
      addParams("layoutId",layoutId)
      // return {isBinExists:findBin}
    } catch (error) {
      const {
        response: {
          data: { message },
        },
      } = error;
      const defaultErrorMessage = "Oops Something went wrong";
      toast.error(message || defaultErrorMessage);
      console.log("error", error);
    } finally {
      visualizerRef?.current?.setLoading(false);
    }
  };

 



  const fetchWarehouses = async (warehouseCode) => {
    visualizerRef?.current?.setLoading(true);
    try {
      const { data } = await axios.get("warehouse-layout", {
        params: {
          warehouseCode: warehouseCode || undefined,
        }
      });
      const warehouses = data?.data;
      // setWarehouses(warehouses);
      dispatch({ type: "CLEAR_ELEMENTS", payload: warehouses || [] });
      dispatch({ type: "SET_WAREHOUSES", payload: warehouses || [] });
      return { warehouses };
    } catch (error) {
      const {
        response: {
          data: { message },
        },
      } = error;
      toast.error(message);
      console.log("error", error);
    } finally {
      visualizerRef?.current?.setLoading(false);
    }
  };

  useEffect(() => {
    if (urlParams.warehouseCode) {
      fetchWarehouses(urlParams.warehouseCode).then(({ warehouses }) => {
        const activeWarehouse = warehouses.find((warehouse) => warehouse.isActive === true);
        fetchLayoutObjects(activeWarehouse?.id).then(() => {
          setLayoutId(activeWarehouse.id)
          eventEmiterInstance.emit("misc/layout-objects-loaded");
        });
      });
    } else {
      toast.error("Unable to find Bin Location in URL");
    }
    
    if (urlParams.binLocation){
      dispatch({type:"SET_GLOBAL_SHOW_LOCATION", payload: { binLocation: urlParams.binLocation }});
    }
  }, []);

  return (
    <div className="element-finder-container">
      {
        layoutId ? (
          <Visualizer ref={visualizerRef} fullscreen />
        ) : <Loader/>
      }
      
    </div>
  );
};

export default ElementFinder;
